import React, { useContext, useEffect, useState } from "react";
import {
    TextField,
    Button,
} from "@mui/material";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import blogFetch from "../../../axios/config";
import Context from "../../../context/Context";
import language from '../../../nls/language.json';
import toast from "react-hot-toast";

const INITIAL_STATE_CREATE_PENDENCY = {
    Molde_Key: 0,
    Molde_Pend_Status: "ABERTO",
    Molde_Pend_Mot_Key: 0,
    Molde_Pend_Obs: ""
}

function Pendency({ data }) {
    const [body, setBody] = useState(INITIAL_STATE_CREATE_PENDENCY);
    const [loading, setLoading] = useState(false);

    const {
        putMold,
        selectedCountry
    } = useContext(Context);

    useEffect(() => {
        setBody({
            ...body,
            Molde_Key: data.moldKey,
        });
    }, [])

    const getMoldePendenciasMotivo = async () => {
        try {
            const { data } = await blogFetch.get(`/ISAGA_MoldePendenciasMotivo`);
            return data;
        } catch (error) {
            console.error(error);
        }
    };

    const postPendencia = async (params) => {
        try {
            setLoading(true);
            if (params.pendency.Molde_Key)
                await addPendencia(params.pendency);
            
            await putMold({
                vagao_Key: params.mold.vagaoKey,
                molde_Key: params.mold.moldKey,
                ordem_Serial: params.mold.ordemSerial,
                status: "MANUTENCAO",
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    }

    const addPendencia = async (params) => {
        try {
            await blogFetch.post(`/ISAGA_MoldePendencias`, params);

            toast.success(language[selectedCountry.name].Moldes.notification.successAddPendency, {
                duration: 4000,
            });
        } catch (error) {
            toast.error(language[selectedCountry.name].Moldes.notification.errorAddPendency, {
                duration: 4000,
            });
        }
    }

    return (
        <div className="d-flex justify-content-center">
            <div className="d-flex flex-column p-3">
                {loading ? (
                    <div>
                        <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                    </div>
                ) : (
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row">
                            <TextField
                                className="header-flex"
                                id="outlined-multiline-flexible"
                                multiline={true}
                                maxRows={10}
                                disabled
                                style={{ width: 160 }}
                                label="Lote"
                                value={data.moldLote}
                            />
                            <TextField
                                className="header-flex"
                                id="outlined-multiline-flexible"
                                multiline={true}
                                maxRows={10}
                                disabled
                                style={{ width: 160, marginLeft: "15px" }}
                                label="Status"
                                value="ABERTO"
                            />
                        </div>
                        <div className="w-100 mt-3 h-10">
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                placeholder="Selecionar Motivo"
                                getOptionLabel={(e) => e.molde_Pend_Mot_Descricao}
                                getOptionValue={(e) => e.molde_Pend_Mot_Descricao}
                                loadOptions={getMoldePendenciasMotivo}
                                onChange={({ molde_Pend_Mot_Key }) => setBody({
                                    ...body,
                                    Molde_Pend_Mot_Key: molde_Pend_Mot_Key,
                                })}
                            />
                        </div>
                        <div className="d-flex mt-3">
                            <TextField
                                className="header-flex"
                                id="outlined-multiline-flexible"
                                multiline={true}
                                maxRows={10}
                                style={{ width: "100%" }}
                                placeholder="Setor Responsável"
                                disabled
                                value="MANUTENCAO"
                            />
                        </div>
                        <div className="d-flex flex justify-content-end mt-3">
                            <Button
                                variant="contained"
                                onClick={() => postPendencia({
                                    pendency: body,
                                    mold: data
                                })}
                                disabled={body.Molde_Pend_Mot_Key === 0}
                            >
                                <div>
                                    {language[selectedCountry.name].Moldes.modal.adicionar.btnSalvar}
                                </div>
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Pendency;
